export const PAGE_TYPE = {
  SignIn: 'SignIn',
  SignUp: 'SignUp',
  ForgotPassword: 'ForgotPassword',
};

export const STEP_FORGOT_EMAIL = [
  { name: 'Tab 1', step: 1 },
  { name: 'Tab 2', step: 2 },
  { name: 'Tab 3', step: 3 },
];

export const FORGOT_PASSWORD_HEADERS = [
  { name: 'Tab 1', step: 1 },
  { name: 'Tab 2', step: 2 },
  { name: 'Tab 3', step: 3 },
  { name: 'Tab 4', step: 4 },
];

export const FORGOT_PASSWORD_STEPS = {
  ENTER_EMAIL: 1,
  CONFIRM_CODE: 2,
  CHANGE_PASSWORD: 3,
  SUCCESS_SCREEN: 4,
};

export const SIGN_UP_HEADERS = [
  { name: 'Tab 1', step: 1 },
  { name: 'Tab 2', step: 2 },
  { name: 'Tab 3', step: 3 },
  { name: 'Tab 4', step: 4 },
];

export const STEP_SIGN_UP = {
  ENTER_ACCOUNT_INFO: 1,
  ENTER_OTP: 2,
  SELECT_ACCOUNT: 3,
  AFTER_APPROVAL: 4,
};

export const STEP_AGENCY_ACCOUNT = {
  ACCOUNT_TYPE_SELECTION: 1,
  ONBOARDING_QUESTIONS: 2,
  PARNER_PROGRAM_OPT_IN: 3,
  FINAL_BEFORE_APPROVAL: 4,
};

export const STEP_AGENCY_ACCOUNT_AFTER_APPROVAL = {
  AFTER_APPROVAL_DIVIDEND_OPTION: 1,
  AFTER_APPROVAL_SMS_OPT_IN: 2,
  AFTER_APPROVAL_INVITE_TEAM_MEMBER: 3,
  AFTER_APPROVAL_WELCOME: 4,
};

export const STEP_ORGANIZATION_ACCOUNT = {
  ACCOUNT_TYPE_SELECTION: 1,
  ONBOARDING_QUESTIONS: 2,
  FINAL_BEFORE_APPROVAL: 3,
};

export const STEP_ORGANIZATION_ACCOUNTT_AFTER_APPROVAL = {
  AFTER_APPROVAL_SMS_OPT_IN: 1,
  AFTER_APPROVAL_INVITE_TEAM_MEMBER: 2,
  AFTER_APPROVAL_WELCOME: 3,
};

export const STEP_CAMPAIGN_ACCOUNT = {
  ACCOUNT_TYPE_SELECTION: 1,
  ONBOARDING_QUESTIONS: 2,
  JOIN_CAMPAIGN_HUB: 3,
  FINAL_BEFORE_APPROVAL: 4,
};

export const STEP_CAMPAIGN_ACCOUNT_FOR_RR = {
  ACCOUNT_TYPE_SELECTION: 1,
  ONBOARDING_QUESTIONS: 2,
  FINAL_BEFORE_APPROVAL: 3,
};

export const STEP_CAMPAIGN_BUSINESS_ACCOUNT_FOR_CONQUEST = {
  ACCOUNT_TYPE_SELECTION: 1,
  ONBOARDING_QUESTIONS: 2,
  FINAL_BEFORE_APPROVAL: 3,
};

export const STEP_CAMPAIGN_ACCOUNT_AFTER_APPROVAL = {
  AFTER_APPROVAL_SMS_OPT_IN: 1,
  AFTER_APPROVAL_INVITE_TEAM_MEMBER: 2,
  AFTER_APPROVAL_WELCOME: 3,
};

export const STEP_ACCOUNT_TYPE_HEADERS = [
  { name: 'Tab 1', step: 1 },
  { name: 'Tab 2', step: 2 },
  { name: 'Tab 3', step: 3 },
  { name: 'Tab 4', step: 4 },
];

export const ACCOUNT_TYPE = {
  AGENCY: 'Agency',
  CAMPAIGN: 'Campaign',
  ORGANIZATION: 'Organization',
};

export const ANSWER_TYPE = {
  Date: 'Date',
  Text: 'Text',
  Domain: 'Domain',
  DropdownList: 'DropdownList',
  MultipleDropdownList: 'MultipleDropdownList',
  SingleChoice: 'SingleChoice',
  MultipleChoice: 'MultipleChoice',
};

export const FIELD_OF_WORK = [
  {
    id: 'GeneralConsultant',
    name: 'field_of_work.general_consultant',
  },
  {
    id: 'DigitalConsultant',
    name: 'field_of_work.digital_consultant',
  },
  {
    id: 'DirectMailConsultant',
    name: 'field_of_work.direct_mail_consultant',
  },
  {
    id: 'TVMediaConsultant',
    name: 'field_of_work.tv_media_consultant',
  },
  {
    id: 'PollingResearchConsultant',
    name: 'field_of_work.polling_research_consultant',
  },
  {
    id: 'OtherNoneOfTheAbove',
    name: 'common.other',
  },
];

export const ORGANIZATION_FIELD_OF_WORK = [
  {
    id: 'PoliticalActionCommittee',
    name: 'organization_field_of_work.political_action_committee',
  },
  {
    id: 'NonProfit',
    name: 'organization_field_of_work.non_profit',
  },
  {
    id: 'Advocacy',
    name: 'organization_field_of_work.advocacy',
  },
  {
    id: 'StateCountyLocalPartyCommittee',
    name: 'organization_field_of_work.state_party_committee',
  },
  {
    id: 'IndependentExpenditureCommittee',
    name: 'organization_field_of_work.independent_expenditure_committee',
  },
  {
    id: 'TradeAssociation',
    name: 'organization_field_of_work.trade_association',
  },
  {
    id: 'ReligiousGroup',
    name: 'organization_field_of_work.religious_group',
  },
  {
    id: 'OtherNoneOfTheAbove',
    name: 'common.other',
  },
];

export const EXPECTED_NUMBER_OF_CLIENTS = [
  {
    id: 'LessThan5',
    name: 'expected_number_of_clients.less_than_5',
  },
  {
    id: 'FiveToTen',
    name: '5-10',
  },
  {
    id: 'TenToTwentyFive',
    name: '10-25',
  },
  {
    id: 'MoreThanTwentyFive',
    name: 'expected_number_of_clients.more_than_25',
  },
];

export const AGENCY_SPEND_LEVEL = [
  {
    id: 'LessThanTenGrand',
    name: 'agency_spend_level.less_than_100k',
  },
  {
    id: 'TenGrandToTwentyFiveGrand',
    name: 'agency_spend_level.100k_250k',
  },
  {
    id: 'TwentyFiveGrandToFiftyGrand',
    name: 'agency_spend_level.250k_500k',
  },
  {
    id: 'FiftyGrandToOneMil',
    name: 'agency_spend_level.500k_1m',
  },
  {
    id: 'OneMilToThreePointFiveMil',
    name: 'agency_spend_level.1_5m_3m',
  },
  {
    id: 'ThreePointFiveMilToFiveMil',
    name: 'agency_spend_level.3_5m_5m',
  },
  {
    id: 'MoreThanFiveMil',
    name: 'agency_spend_level.more_than_5m',
  },
];

export const AGENCY_INTERESTED_AD_CAMPAIGN_TYPE = [
  {
    id: 'BrandAwareness',
    name: 'interested_ad_campaign_type.brand_awareness',
  },
  {
    id: 'DriveNewLeads',
    name: 'interested_ad_campaign_type.drive_new_leads',
  },
  {
    id: 'CustomerPurchaseConversion',
    name: 'interested_ad_campaign_type.customer_purchase_conversion',
  },
  {
    id: 'SupportOrOpposeElectoral',
    name: 'interested_ad_campaign_type.support_oppose_electoral',
  },
  {
    id: 'IssueAdvocacyPublic',
    name: 'interested_ad_campaign_type.issue_advocacy_public',
  },
  {
    id: 'IssueAdvocacyLeg',
    name: 'interested_ad_campaign_type.issue_advocacy_leg',
  },
  {
    id: 'ListGrowthDonorCpa',
    name: 'interested_ad_campaign_type.list_growth_donor_cpa',
  },
  {
    id: 'Other',
    name: 'common.other',
    otherKey: 'otherAdCampaignTypes',
    isOther: true,
    placeholder: 'interested_ad_campaign_type.tell_us_more',
  },
];


export const ORG_INTERESTED_AD_CAMPAIGN_TYPE = [
  {
    id: 'SupportOrOpposeElectoral',
    name: 'interested_ad_campaign_type.support_oppose_electoral',
  },
  {
    id: 'IssueAdvocacyPublic',
    name: 'interested_ad_campaign_type.issue_advocacy_public',
  },
  {
    id: 'IssueAdvocacyLeg',
    name: 'interested_ad_campaign_type.issue_advocacy_leg',
  },
  {
    id: 'ListGrowthDonorCpa',
    name: 'interested_ad_campaign_type.list_growth_donor_cpa',
  },
  {
    id: 'MembershipDrivers',
    name: 'interested_ad_campaign_type.membership_drivers',
  },
  {
    id: 'BrandAwareness',
    name: 'interested_ad_campaign_type.brand_awareness',
  },
  {
    id: 'Other',
    name: 'common.other',
    otherKey: 'otherAdCampaignTypes',
    isOther: true,
    placeholder: 'interested_ad_campaign_type.tell_us_more',
  },
];

export const REFERRAL_SOURCE = [
  {
    id: 'SearchEngine',
    name: 'referral_source.search_engine',
  },
  {
    id: 'SocialMedia',
    name: 'referral_source.social_media',
  },
  { id: 'Postcard', name: 'referral_source.postcard' },
  { id: 'Email', name: 'referral_source.email' },

  { id: 'WebinarTrainingEvent', name: 'referral_source.webinar_training_event' },
  {
    id: 'Referral',
    name: 'referral_source.referral',
    isOther: true,
    otherKey: 'referredBy',
    placeholder: 'referral_source.who_can_we_thank',
  },
];

export const LEVEL_OF_OFFICE = [
  {
    id: 'StateHouse',
    name: 'level_of_office.state_house',
  },
  {
    id: 'StateSenate',
    name: 'level_of_office.state_senate',
  },
  {
    id: 'Mayoral',
    name: 'level_of_office.mayoral',
  },
  {
    id: 'CityCouncil',
    name: 'level_of_office.city_council',
  },
  {
    id: 'OtherMunicipal',
    name: 'level_of_office.other_municipal',
  },
  {
    id: 'UsSenate',
    name: 'level_of_office.us_senate',
  },
  {
    id: 'UsHouse',
    name: 'level_of_office.us_house',
  },
  {
    id: 'OtherStatewide',
    name: 'level_of_office.other_statewide',
  },
  {
    id: 'NotApplicable',
    name: 'level_of_office.not_applicable',
  },
  {
    id: 'BallotMeasureIssueCampaign',
    name: 'level_of_office.ballot_measure_issue_campaign',
  },
];

export const BUSINESS_DESCRIPTION_TYPE = [
  {
    id: 'BankingFinancialServices',
    name: 'business_description_type.banking_financial_services',
  },
  {
    id: 'BusinessServices',
    name: 'business_description_type.business_services',
  },
  {
    id: 'ConsumerPackagedGoods',
    name: 'business_description_type.consumer_packaged_goods',
  },
  {
    id: 'CoursesELearning',
    name: 'business_description_type.courses_e_learning',
  },
  {
    id: 'ConsultingServices',
    name: 'business_description_type.consulting_services',
  },
  {
    id: 'TechnologyServices',
    name: 'business_description_type.technology_services',
  },
  {
    id: 'SoftwareSales',
    name: 'business_description_type.software_sales',
  },
  {
    id: 'Cryptocurrency',
    name: 'business_description_type.cryptocurrency',
  },
  {
    id: 'AppsGaming',
    name: 'business_description_type.apps_gaming',
  },
  {
    id: 'RetailSales',
    name: 'business_description_type.retail_sales',
  },
  {
    id: 'LegalServices',
    name: 'business_description_type.legal_services',
  },
  {
    id: 'Healthcare',
    name: 'business_description_type.healthcare',
  },
  {
    id: 'PrecriptionDrugs',
    name: 'business_description_type.prescription_drugs',
  },
  {
    id: 'Cannabis',
    name: 'business_description_type.cannabis',
  },
  {
    id: 'CBDHemp',
    name: 'business_description_type.cbd_hemp',
  },
  {
    id: 'FoodAndBeverage',
    name: 'business_description_type.food_and_beverage',
  },
  {
    id: 'KickstarterCrowdfunding',
    name: 'business_description_type.kickstarter_crowdfunding',
  },
  {
    id: 'Other',
    name: 'business_description_type.other',
    otherKey: 'businessOtherTypeDetails',
    isOther: true,
    placeholder: 'business.tell_us_more',
  },
];

export const BUSINESS_GOALS = [
  {
    id: 'BrandAwareness',
    name: 'business_goals.brand_awareness',
  },
  {
    id: 'NewLeads',
    name: 'business_goals.new_leads',
  },
  {
    id: 'ProductPurchase',
    name: 'business_goals.product_purchase',
  },
  {
    id: 'Other',
    name: 'business_goals.other',
    otherKey: 'businessOtherGoalsDetail',
    isOther: true,
    placeholder: 'business.tell_us_more',
  },
];

export const CAMPAIGN_SPEND_LEVEL = [
  {
    id: 'LessThanFiveThousand',
    name: 'campaign_spend_level.less_than_5k',
  },
  {
    id: 'FiveThousandToTenThousand',
    name: 'campaign_spend_level.5k_10k',
  },
  {
    id: 'TenThousandToTwentyFiveThousand',
    name: 'campaign_spend_level.10k_25k',
  },
  {
    id: 'TwentyFiveThousandToFiftyThousand',
    name: 'campaign_spend_level.25k_50k',
  },
  {
    id: 'MoreThanFiftyThousand',
    name: 'campaign_spend_level.more_than_50k',
  },
];

export const AGENCY_QUESTION_STEPS = [
  {
    step: 0,
    list: [
      {
        key: 'companyName',
        question: 'agency_question_steps.company_name',
        placeholder: 'agency_question_steps.company_name_placeholder',
        type: ANSWER_TYPE.Text,
      },
      {
        key: 'urlDomain',
        question: 'agency_question_steps.url_domain',
        placeholder: 'agency_question_steps.url_domain_placeholder',
        type: ANSWER_TYPE.Domain,
      },
      {
        key: 'fieldsOfWork',
        question: 'agency_question_steps.fields_of_work',
        placeholder: 'agency_question_steps.fields_of_work_placeholder',
        type: ANSWER_TYPE.MultipleDropdownList,
        options: FIELD_OF_WORK,
      },
    ],
  },
  {
    step: 1,
    list: [
      {
        key: 'expectedNumberOfClients',
        question: 'agency_question_steps.expected_number_of_clients',
        placeholder: 'agency_question_steps.expected_number_of_clients_placeholder',
        type: ANSWER_TYPE.DropdownList,
        options: EXPECTED_NUMBER_OF_CLIENTS,
      },
      {
        key: 'agencySpendLevel',
        question: 'agency_question_steps.agency_spend_level',
        placeholder: 'agency_question_steps.agency_spend_level_placeholder',
        type: ANSWER_TYPE.DropdownList,
        options: AGENCY_SPEND_LEVEL,
      },
      {
        key: 'needingCreativeProductionSupport',
        question: 'agency_question_steps.needing_creative_production_support',
        description: 'agency_question_steps.needing_creative_production_support_description',
        type: ANSWER_TYPE.SingleChoice,
        singleChoice: [
          {
            id: 'Yes',
            name: 'common.yes',
          },
          {
            id: 'No',
            name: 'common.no',
          },
          {
            id: 'NotSure',
            name: 'agency_question_steps.needing_creative_production_support_not_sure',
          },
        ],
      },
    ],
  },
  {
    step: 2,
    list: [
      {
        key: 'interestedAdCampaignTypes',
        question: 'agency_question_steps.interested_ad_campaign_types',
        type: ANSWER_TYPE.MultipleChoice,
        options: AGENCY_INTERESTED_AD_CAMPAIGN_TYPE,
      },
    ],
  },
];

export const ORGANIZATION_QUESTION_STEPS = [
  {
    step: 0,
    list: [
      {
        key: 'companyName',
        question: 'organization_question_steps.company_name',
        placeholder: 'organization_question_steps.company_name_placeholder',
        type: ANSWER_TYPE.Text,
      },
      {
        key: 'urlDomain',
        question: 'organization_question_steps.url_domain',
        placeholder: 'organization_question_steps.url_domain_placeholder',
        type: ANSWER_TYPE.Domain,
      },
      {
        key: 'organizationTypes',
        question: 'organization_question_steps.organization_types',
        placeholder: 'organization_question_steps.organization_types_placeholder',
        type: ANSWER_TYPE.MultipleDropdownList,
        options: ORGANIZATION_FIELD_OF_WORK,
      },
    ],
  },
  {
    step: 1,
    list: [
      {
        key: 'interestedAdCampaignTypes',
        question: 'organization_question_steps.interested_ad_campaign_types',
        type: ANSWER_TYPE.MultipleChoice,
        options: ORG_INTERESTED_AD_CAMPAIGN_TYPE,
      },
      {
        key: 'needingCreativeProductionSupport',
        question: 'organization_question_steps.needing_creative_production_support',
        type: ANSWER_TYPE.SingleChoice,
        singleChoice: [
          {
            id: 'Yes',
            name: 'common.yes',
          },
          {
            id: 'No',
            name: 'common.no',
          },
          {
            id: 'NotSure',
            name: 'agency_question_steps.needing_creative_production_support_not_sure',
          },
        ],
      },
    ],
  },
];

export const CAMPAIGN_QUESTION_STEPS = [
  {
    step: 0,
    list: [
      {
        key: 'companyName',
        question: 'campaign_question_steps.company_name',
        placeholder: 'campaign_question_steps.company_name_placeholder',
        type: ANSWER_TYPE.Text,
      },
      {
        key: 'urlDomain',
        question: 'campaign_question_steps.url_domain',
        placeholder: 'campaign_question_steps.url_domain_placeholder',
        type: ANSWER_TYPE.Domain,
      },
      {
        key: 'campaignType',
        question: 'campaign_question_steps.campaign_type',
        type: ANSWER_TYPE.SingleChoice,
        isFullWidth: true,
        singleChoice: [
          { id: 'Candidate', name: 'campaign_question_steps.candidate_campaign' },
          { id: 'Cause', name: 'campaign_question_steps.cause_campaign' },
          {
            id: 'Other',
            name: 'campaign_question_steps.something_else',
            isOther: true,
            otherKey: 'otherCampaignType',
            placeholder: 'campaign_question_steps.something_else_placeholder',
          },
        ],
      },
    ],
  },
  {
    step: 1,
    list: [
      {
        key: 'levelOfOffice',
        question: 'campaign_question_steps.level_of_office',
        placeholder: 'campaign_question_steps.level_of_office_placeholder',
        type: ANSWER_TYPE.DropdownList,
        options: LEVEL_OF_OFFICE,
      },
      {
        key: 'electionType',
        question: 'campaign_question_steps.election_type',
        type: ANSWER_TYPE.SingleChoice,
        isFullWidth: true,
        singleChoice: [
          { id: 'Primary', name: 'campaign_question_steps.primary_campaign_only' },
          {
            id: 'General',
            name: 'campaign_question_steps.general_election_campaign_only',
          },
          {
            id: 'Both',
            name: 'campaign_question_steps.both_primary_and_general',
          },
        ],
      },
      {
        key: 'primaryElectionDate',
        question: 'campaign_question_steps.primary_election_date',
        placeholder: 'campaign_question_steps.primary_election_date_placeholder',
        type: ANSWER_TYPE.Date,
      },
      {
        key: 'generalElectionDate',
        question: 'campaign_question_steps.general_election_date',
        placeholder: 'campaign_question_steps.general_election_date_placeholder',
        type: ANSWER_TYPE.Date,
      },
    ],
  },
  {
    step: 2,
    list: [
      {
        key: 'needingCreativeProductionSupport',
        question: 'campaign_question_steps.needing_creative_production_support',
        type: ANSWER_TYPE.SingleChoice,
        singleChoice: [
          { id: 'Yes', name: 'campaign_question_steps.need_help_producing_ads' },
          { id: 'No', name: 'campaign_question_steps.already_have_ads' },
          { id: 'NotSure', name: 'campaign_question_steps.not_sure_yet' },
        ],
      },
      {
        key: 'campaignSpendLevel',
        question: 'campaign_question_steps.campaign_spend_level',
        description: 'campaign_question_steps.campaign_spend_level_description',
        placeholder: 'campaign_question_steps.campaign_spend_level_placeholder',
        type: ANSWER_TYPE.DropdownList,
        options: CAMPAIGN_SPEND_LEVEL,
      },
      {
        key: 'launchCampaignMoment',
        question: 'campaign_question_steps.launch_campaign_moment',
        type: ANSWER_TYPE.SingleChoice,
        isFullWidth: true,
        singleChoice: [
          { id: 'Asap', name: 'campaign_question_steps.asap' },
          { id: 'FewDays', name: 'campaign_question_steps.within_next_few_days' },
          {
            id: 'AMonth',
            name: 'campaign_question_steps.a_month_or_so',
          },
          {
            id: 'NotYet',
            name: 'campaign_question_steps.just_checking',
          },
        ],
      },
    ],
  },
];

export const CAMPAIGN_QUESTION_STEPS_WITHOUT_CANDIDATE = [
  {
    step: 0,
    list: [
      {
        key: 'companyName',
        question: 'campaign_question_steps.company_name',
        placeholder: 'campaign_question_steps.company_name_placeholder',
        type: ANSWER_TYPE.Text,
      },
      {
        key: 'urlDomain',
        question: 'campaign_question_steps.url_domain',
        placeholder: 'campaign_question_steps.url_domain_placeholder',
        type: ANSWER_TYPE.Domain,
      },
      {
        key: 'campaignType',
        question: 'campaign_question_steps.campaign_type',
        type: ANSWER_TYPE.SingleChoice,
        isFullWidth: true,
        singleChoice: [
          { id: 'Candidate', name: 'campaign_question_steps.candidate_campaign' },
          { id: 'Cause', name: 'campaign_question_steps.cause_campaign' },
          {
            id: 'Other',
            name:  'campaign_question_steps.something_else',
            isOther: true,
            otherKey: 'otherCampaignType',
            placeholder: 'campaign_question_steps.something_else_placeholder',
          },
        ],
      },
    ],
  },
  {
    step: 1,
    list: [
      {
        key: 'generalElectionDate',
        question:  'campaign_question_steps.general_election_date',
        placeholder: 'campaign_question_steps.general_election_date_placeholder',
        type: ANSWER_TYPE.Date,
      },
      {
        key: 'needingCreativeProductionSupport',
        question: 'campaign_question_steps.needing_creative_production_support',
        type: ANSWER_TYPE.SingleChoice,
        singleChoice: [
          { id: 'Yes', name:  'campaign_question_steps.need_help_producing_ads' },
          { id: 'No', name: 'campaign_question_steps.already_have_ads' },
          { id: 'NotSure', name: 'campaign_question_steps.not_sure_yet' },
        ],
      },
    ],
  },
  {
    step: 2,
    list: [
      {
        key: 'campaignSpendLevel',
        question: 'campaign_question_steps.campaign_spend_level',

        description:
          'campaign_question_steps.campaign_spend_level_description',
        placeholder: 'campaign_question_steps.campaign_spend_level_placeholder',
        type: ANSWER_TYPE.DropdownList,
        options: CAMPAIGN_SPEND_LEVEL,
      },
      {
        key: 'launchCampaignMoment',
        question: 'campaign_question_steps.launch_campaign_moment',
        type: ANSWER_TYPE.SingleChoice,
        isFullWidth: true,
        singleChoice: [
          { id: 'Asap', name: 'campaign_question_steps.asap' },
          { id: 'FewDays', name: 'campaign_question_steps.within_next_few_days' },
          {
            id: 'AMonth',
            name: 'campaign_question_steps.a_month_or_so',
          },
          {
            id: 'NotYet',
            name: 'campaign_question_steps.just_checking',
          },
        ],
      },
    ],
  },
];

// For CONQUEST DSP use only
export const CAMPAIGN_BUSINESS_QUESTION_STEPS = [
  {
    step: 0,
    list: [
      {
        key: 'companyName',
        question: 'campaign_question_steps.business_name',
        placeholder: 'conquest_campaign_question_steps.company_name_placeholder',
        type: ANSWER_TYPE.Text,
      },
      {
        key: 'urlDomain',
        question: 'campaign_question_steps.business_url_domain',
        placeholder: 'conquest_campaign_question_steps.url_domain_placeholder',
        type: ANSWER_TYPE.Domain,
      }
    ],
  },
  {
    step: 1,
    list: [
      {
        key: 'businessDescriptionType',
        question: 'campaign_question_steps.business_description_type',
        placeholder: 'campaign_question_steps.business_description_type_placeholder',
        type: ANSWER_TYPE.DropdownList,
        options: BUSINESS_DESCRIPTION_TYPE,
      },
      {
        key: 'businessGoals',
        question: 'campaign_question_steps.business_goals',
        placeholder: 'campaign_question_steps.business_goals_placeholder',
        type: ANSWER_TYPE.MultipleChoice,
        options: BUSINESS_GOALS,
      },
    ],
  },
  {
    step: 2,
    list: [
      {
        key: 'needingCreativeProductionSupport',
        question: 'campaign_question_steps.needing_creative_production_support',
        type: ANSWER_TYPE.SingleChoice,
        singleChoice: [
          { id: 'Yes', name: 'campaign_question_steps.need_help_producing_ads' },
          { id: 'No', name: 'campaign_question_steps.already_have_ads' },
          { id: 'NotSure', name: 'campaign_question_steps.not_sure_yet' },
        ],
      },
      {
        key: 'campaignSpendLevel',
        question: 'campaign_question_steps.campaign_business_spend_level',
        placeholder: 'campaign_question_steps.campaign_spend_level_placeholder',
        type: ANSWER_TYPE.DropdownList,
        options: CAMPAIGN_SPEND_LEVEL,
      },
      {
        key: 'launchCampaignMoment',
        question: 'campaign_question_steps.launch_campaign_moment',
        type: ANSWER_TYPE.SingleChoice,
        isFullWidth: true,
        singleChoice: [
          { id: 'Asap', name: 'campaign_question_steps.asap' },
          { id: 'FewDays', name: 'campaign_question_steps.within_next_few_days' },
          {
            id: 'AMonth',
            name: 'campaign_question_steps.a_month_or_so',
          },
          {
            id: 'NotYet',
            name: 'campaign_question_steps.just_checking',
          },
        ],
      },
    ],
  },
];

export const INIT_VALUE_AGENCY_ACCOUNT = {
  token: '',
  urlDomain: '',
  email: '',
  firstName: '',
  lastName: '',
  referralCode: '',
  otp: '',
  companyName: '',
  fieldsOfWork: [],
  expectedNumberOfClients: null,
  agencySpendLevel: null,
  needingCreativeProductionSupport: null,
  interestedAdCampaignTypes: [],
  otherAdCampaignTypes: '',
  referralSources: [],
  joinAgencyPartnerProgram: true,
  referredBy: '',
};

export const INIT_VALUE_ORG_ACCOUNT = {
  token: '',
  urlDomain: '',
  email: '',
  firstName: '',
  lastName: '',
  referralCode: '',
  otp: '',
  companyName: '',
  referralSources: [],
  referredBy: '',
  organizationTypes: [],
  interestedAdCampaignTypes: [],
  otherAdCampaignTypes: '',
  needingCreativeProductionSupport: null,
};

export const INIT_VALUE_CAMPAIGN_ACCOUNT = {
  token: '',
  urlDomain: '',
  email: '',
  firstName: '',
  lastName: '',
  referralCode: '',
  otp: '',
  companyName: '',
  referralSources: [],
  referredBy: '',
  campaignType: '',
  otherCampaignType: '',
  levelOfOffice: '',
  electionType: '',
  primaryElectionDate: null,
  generalElectionDate: null,
  needingCreativeProductionSupport: null,
  campaignSpendLevel: '',
  launchCampaignMoment: '',
  joinCampaignHub: true,
  businessDescriptionType: '',
  businessGoals: [],
};

export const ACCOUNT_LEVELS = {
  Admin: 'Admin',
  CampaignManager: 'CampaignManager',
  AnalyticManager: 'AnalyticManager',
};
